<template>
	<!-- 保护 -->
	<div class="preserve-icon">
		<img v-for="item in imgList" :class="'icon'+item" :data-src="g+'/'+item+'.png'" />
	</div>
</template>

<script>
	export default {
		name: "",
		components: {},
		data() {
			let g = process.env.VUE_APP_BASE_URL + 'sustainability'
			return {
				g: g,
				imgList: ['115', '116', '117', '118', '119', '120', '121', '122', '123', '124', '125', '126', '127'],
			}
		}
	}
</script>

<style lang="scss" scoped>
	.preserve-icon {
		height: 59.58px;
		left: 0px;
		position: relative;
		top: 0px;
		transform-origin: 0% 0%;
		width: 61.82px;

		.icon115 {
			height: 45.07px;
			left: 0px;
			position: absolute;
			top: 0px;
			transform: translate(16.139px, 13.421px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
			transform-origin: 0% 0%;
			width: 31.27px
		}

		.icon116 {
			height: 9.58px;
			left: 0px;
			position: absolute;
			top: 0px;
			transform: translate(26.197px, 27.720px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
			transform-origin: 0% 0%;
			width: 11.16px;
		}

		.icon117 {
			height: 7.27px;
			left: 0px;
			position: absolute;
			top: 0px;
			transform: translate(33.832px, 30.731px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
			transform-origin: 0% 0%;
			width: 6.81px;
		}

		.icon118 {
			height: 2.67px;
			left: 0px;
			position: absolute;
			top: 0px;
			transform: translate(23.289px, 55.203px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
			transform-origin: 0% 0%;
			width: 6.33px;
		}

		.icon119 {
			height: 3.22px;
			left: 0px;
			position: absolute;
			top: 0px;
			transform: translate(38.216px, 55.615px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
			transform-origin: 0% 0%;
			width: 5.25px;
		}

		.icon120 {
			height: 3.68px;
			left: 0px;
			position: absolute;
			top: 0px;
			transform: translate(33.031px, 55.694px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
			transform-origin: 0% 0%;
			width: 4.51px;
		}

		.icon121 {
			height: 4.58px;
			left: 0px;
			position: absolute;
			top: 0px;
			transform: translate(34.364px, 54.431px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
			transform-origin: 0% 0%;
			width: 4.05px
		}

		.icon122 {
			height: 5.03px;
			left: 0px;
			position: absolute;
			top: 0px;
			transform: translate(30.512px, 54.148px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
			transform-origin: 0% 0%;
			width: 2.25px;
		}

		.icon123 {
			height: 1.92px;
			left: 0px;
			position: absolute;
			top: 0px;
			transform: translate(25.556px, 57.023px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
			transform-origin: 0% 0%;
			width: 4.12px;
		}

		.icon124 {
			height: 1.33px;
			left: 0px;
			position: absolute;
			top: 0px;
			transform: translate(24.664px, 32.447px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
			transform-origin: 0% 0%;
			width: 1.53px;
		}

		.icon125 {
			height: 1.00px;
			left: 0px;
			position: absolute;
			top: 0px;
			transform: translate(24.232px, 33.849px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
			transform-origin: 0% 0%;
			width: 1.36px;
		}

		.icon126 {
			height: 57.66px;
			left: 0px;
			position: absolute;
			top: 0px;
			transform: translate(-0.001px, 1.924px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
			transform-origin: 0% 0%;
			width: 29.37px;
		}

		.icon127 {
			height: 56.54px;
			left: 0px;
			position: absolute;
			top: 0px;
			transform: translate(32.612px, -0.001px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
			transform-origin: 0% 0%;
			width: 29.21px;
		}
	}
</style>